<script>
	import { Modal, ModalBody, ModalHeader , Container, Row ,Col} from 'sveltestrap';
    
    let open = false;
	/**
	 * Toggle modal
	 */
	const toggle = () => {
		open = !open;
	};
</script>

<!--START HOME-->

<section class="section bg-home home-half common-section" id="home" data-image-src="images/img-2.jpg">
	<div class="bg-overlay" />
	<Container>
		<Row class="justify-content-center">
			<Col lg={8} class="text-white text-center">
				<h4 class="home-small-title">Le damos la bienvenida a</h4>
				<h1 class="home-title">Plataforma Conecta</h1>
				<p class="pt-3 home-desc mx-auto">
					La Plataforma Cloud del Consejo General de Colegios de Administradores de Fincas de España.
				</p>
			</Col>
		</Row>
	</Container>
	<div class="wave-effect wave-anim">
		<div class="waves-shape shape-one">
			<div class="wave wave-one" style="background-image: url('images/wave-shape/wave1.png')"></div>
		</div>
		<div class="waves-shape shape-two">
			<div class="wave wave-two" style="background-image: url('images/wave-shape/wave2.png')"></div>
		</div>
		<div class="waves-shape shape-three">
			<div class="wave wave-three" style="background-image: url('images/wave-shape/wave3.png')"></div>
		</div>
	</div>
</section>

<!--END HOME-->